import { Component, computed, input, Input, InputSignal, OnInit, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import {
  AdPlacementRoadOccupationFormValue, occupationsToAdPlacementRoadOccupationFormValues
} from '../../placement-advertising/sections/ad-placement-section/forms/ad-placement-road-occupation.form';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../../../../../common/label/label.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';

@Component({
  selector: 'app-permit-for-oversize-vehicles-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    LabelComponent,
    CommonModule,
    DecisionDataPreviewComponent
  ],
  templateUrl: './permit-for-oversize-vehicles-preview.component.html'
})
export class PermitForOversizeVehiclesPreviewComponent implements OnInit {
  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public roadOccupations: Signal<AdPlacementRoadOccupationFormValue[]> = computed(() => occupationsToAdPlacementRoadOccupationFormValues(this.application()));

  public ngOnInit(): void {
  }
}
